import { isMobile } from 'react-device-detect';

const STORY_IMAGE_URL = '/images/SpreadTheVote_Instagram_Story.png';
const PROFILE_URL = 'https://www.instagram.com/spreadthevotencl/';

// iOS blocks other apps (including Instagram) from reading pasteboard data
// written via the JS Clipboard API, so the classic "copy image + open
// instagram-stories://share" trick doesn't work from a website anymore.
// The Web Share API's file support opens the native OS share sheet instead,
// which hands the image to Instagram's own share extension - the same path
// used when sharing a photo to Instagram from any other app.
const shareToInstagramStory = async () => {
    // Desktop Chrome/Edge/Safari also support navigator.share() with files,
    // but Instagram Stories is a mobile-only feature - skip straight to the
    // profile page there instead of surfacing a share dialog that doesn't
    // make sense on a computer.
    if (!isMobile) {
        window.open(PROFILE_URL, '_blank', 'noopener,noreferrer');
        return;
    }

    try {
        const response = await fetch(STORY_IMAGE_URL);
        const blob = await response.blob();
        const file = new File([blob], 'spread-the-vote.png', {
            type: blob.type,
        });

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
                files: [file],
                title: 'Spread The Vote',
                text: 'Share to your Instagram Story',
            });
            return;
        }
    } catch (error) {
        if (error && error.name === 'AbortError') {
            // User cancelled the share sheet - respect that instead of
            // redirecting them to the profile page.
            return;
        }
        // Otherwise fall through to the profile page below.
    }

    window.open(PROFILE_URL, '_blank', 'noopener,noreferrer');
};

export default shareToInstagramStory;
